/**
 * Arranque de la UI de monitoreo.
 *
 * El cliente HTTP se construye una sola vez, antes del arbol de componentes: lee
 * el ID token del `token-store` en cada request, asi no hay que reconstruirlo
 * cuando el usuario entra o sale.
 *
 * `ThemeProvider` va por fuera de todo: el tema es del documento entero, login
 * incluido (ver `app/theme.tsx`).
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { createHttpMonitorApi } from './api/http-monitor-api';
import { MonitorApiProvider } from './app/api-context';
import { readEnvironment } from './app/environment';
import { applyEnvironmentFavicon } from './app/favicon';
import { ThemeProvider } from './app/theme';
import { AuthProvider } from './auth/auth-context';
import './styles/global.css';

const container = document.getElementById('root');
if (container === null) {
  // Sin punto de montaje no hay nada que hacer, y hay que decirlo fuerte.
  throw new Error('No se encontro el elemento #root en index.html.');
}

const environment = readEnvironment();
applyEnvironmentFavicon(environment.environmentLabel);
const api = createHttpMonitorApi({ baseUrl: environment.apiBaseUrl });

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <MonitorApiProvider api={api}>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </MonitorApiProvider>
    </ThemeProvider>
  </StrictMode>,
);
